var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", [
      _c(
        "span",
        { staticClass: "search-preference__title" },
        [
          _vm._v(" " + _vm._s(_vm.label) + " "),
          _c(
            "ElPopover",
            {
              attrs: {
                placement: "right",
                trigger: "hover",
                "visible-arrow": false,
              },
            },
            [
              _c("AlignmentExplanation", { attrs: { "img-src": _vm.imgSrc } }),
              _vm.hasExplain
                ? _c("PtIcon", {
                    attrs: { slot: "reference", icon: "SolidInfo" },
                    slot: "reference",
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "search-preference__slider-row" }, [
      _c(
        "div",
        { staticClass: "search-preference__slider bio-slider" },
        [
          _c("ElSlider", {
            attrs: { min: 0, max: 100, "show-tooltip": false, range: "" },
            on: { change: _vm.onValueChange },
            model: {
              value: _vm.innerValue,
              callback: function ($$v) {
                _vm.innerValue = $$v
              },
              expression: "innerValue",
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "search-preference__coverage" }, [
        _c("div", { staticClass: "base-input base-input-group" }, [
          _c("input", {
            staticClass: "base-input__inner",
            attrs: { type: "text" },
            domProps: { value: _vm.innerValue[0] },
            on: {
              keypress: function ($event) {
                return _vm.isNumber($event)
              },
              blur: _vm.onStartChange,
            },
          }),
          _c("span", { staticClass: "separator" }),
          _c("input", {
            staticClass: "base-input__inner",
            attrs: { type: "text" },
            domProps: { value: _vm.innerValue[1] },
            on: {
              keypress: function ($event) {
                return _vm.isNumber($event)
              },
              blur: _vm.onEndChange,
            },
          }),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }